import React from "react";
import "./newStats.css"; // New CSS file name
import { useTranslation } from "react-i18next";
import useRTLContext from "../../../hooks/useRTLContext";

export default function Stats({ statsData }) {
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="stats-container">
        {statsData?.map((stat, index) => (
          <div className="stats-item" key={stat.name}>
            <div className="stats-card">
              <div className="stats-icon">
                <img src={stat.icon} alt={t(stat.iconAlt)} />
              </div>
              <div className="stats-content">
                <div className="stats-count">{stat.count}</div>
                <div className="stats-label">{t(stat.name)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
